<template>
	<div class="layout layout--flush mh0 p- mb u-bg-color-grey--x-light zeta layout--flex layout--flex-wrap">
		<div class="layout__item layout__item--flex-fill u-1/4 u-1/1-palm" v-if="electricityTariffs">
			<h6 class="u-weight--normal u-palm-display--inline-block u-white-space--nowrap">Stroom</h6>
			<div class="layout pb-">
				<div class="layout__item u-1/2">
					<div v-for="(t, index) in electricityTariffs.high" :key="index">
						<span class="u-white-space--nowrap">
							<span class="c-spec zeta">{{ t.Value }}</span>
							<small class="u-text-color-grey">&nbsp;{{ t.Unit }}/kWh</small>
						</span>

						<div class="small" v-if="electricityTariffs.hasStacked">{{ t.ToolTip }}</div>
						<div class="small" v-if="electricityTariffs.low.length > 0">Normaaltarief</div>
					</div>
				</div>

				<div
					class="layout__item layout__item--flex-fill u-1/2 palm-pl-"
					v-if="electricityTariffs.low.length > 0"
				>
					<div v-for="(t, index) in electricityTariffs.low" :key="index">
						<span class="u-white-space--nowrap">
							<span class="c-spec zeta">{{ t.Value }}</span>
						</span>
						<small class="u-text-color-grey">&nbsp;{{ t.Unit }}/kWh</small>
						<div class="small" v-if="electricityTariffs.hasStacked">{{ t.ToolTip }}</div>
						<div class="small">Daltarief</div>
					</div>
				</div>
			</div>
		</div>
		<div class="layout__item layout__item--flex-fill u-1/4 u-1/1-palm" v-if="hasRedelivery">
			<h6 class="u-weight--normal u-palm-display--inline-block u-white-space--nowrap">Teruglevering</h6>
			<div class="layout">
				<div class="layout__item u-1/2">
					<div v-for="(t, index) in electricityRedeliveryTariffs.high" :key="index">
						<span class="u-white-space--nowrap">
							<span class="c-spec zeta">{{ t.Value }}</span>
							<small class="u-text-color-grey">&nbsp;{{ t.Unit }}/kWh</small>
						</span>
						<div class="small" v-if="electricityTariffs.hasStacked">{{ t.ToolTip }}</div>
						<div class="small" v-if="electricityTariffs.low.length > 0">Normaaltarief</div>
					</div>
				</div>

				<div class="layout__item palm-pl- u-1/2" v-if="electricityRedeliveryTariffs.low.length > 0">
					<div v-for="(t, index) in electricityRedeliveryTariffs.low" :key="index">
						<span class="u-white-space--nowrap">
							<span class="c-spec zeta">{{ t.Value }}</span>
							<small class="u-text-color-grey">&nbsp;{{ t.Unit }}/kWh</small>
						</span>
						<div class="small" v-if="electricityTariffs.hasStacked">{{ t.ToolTip }}</div>
						<div class="small">Daltarief</div>
					</div>
				</div>
			</div>
		</div>
		<div class="layout__item layout__item--flex-fill u-1/10 u-1/2-palm" v-if="hasGas && tariffs.GasTariffs">
			<h6 class="u-weight--normal u-palm-display--inline-block u-white-space--nowrap">Gas</h6>
			<div v-for="(t, index) in tariffs.GasTariffs" :key="index" class="u-white-space--nowrap">
				<span class="c-spec zeta">{{ t.Value }}</span>
				<small class="u-text-color-grey">&nbsp;{{ t.Unit }}/m3</small>
				<div class="small" v-if="t.ToolTip">{{ t.ToolTip }}</div>
			</div>
		</div>
		<div class="layout__item layout__item--flex-fill u-1/5 u-1/2-palm">
			<h6 class="u-weight--normal u-palm-display--inline-block u-white-space--nowrap">Vaste leveringskosten</h6>
			<div>
				<span class="c-spec zeta">&euro; {{ tariffs.FixedAmount.Value }}</span
				>&nbsp;
				<span class="small u-font-weight--normal">{{ tariffs.FixedAmount.ToolTip }}</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		tariffs: {
			type: Object,
			default: () => {},
		},
		inTab: {
			type: Boolean,
			default: () => false,
		},
	},
	components: {},
	computed: {
		hasHighLow: function () {
			if (!this.tariffs) {
				return false;
			}

			return this.tariffs.ElectricityTariffs.filter((t) => t.Text.toLowerCase().indexOf('dal') > -1).length > 0;
		},
		electricityTariffs: function () {
			if (!this.tariffs || !this.tariffs.ElectricityTariffs) {
				return null;
			}
			const highTarifs = this.tariffs.ElectricityTariffs.filter(
				(t) => t.Text.toLowerCase().indexOf('dal') === -1
			);
			const lowTariffs = this.tariffs.ElectricityTariffs.filter((t) => t.Text.toLowerCase().indexOf('dal') > -1);
			return {
				high: highTarifs,
				low: lowTariffs,
				hasStacked: highTarifs.length > 1,
			};
		},
		electricityRedeliveryTariffs: function () {
			if (!this.tariffs || !this.tariffs.ElectricityRedeliveryTariffs) {
				return null;
			}
			const highTarifs = this.tariffs.ElectricityRedeliveryTariffs.filter(
				(t) => t.Text.toLowerCase().indexOf('dal') === -1
			);
			const lowTariffs = this.tariffs.ElectricityRedeliveryTariffs.filter(
				(t) => t.Text.toLowerCase().indexOf('dal') > -1
			);
			return {
				high: highTarifs,
				low: lowTariffs,
				hasStacked: highTarifs.length > 1,
			};
		},
		hasRedelivery: function () {
			return this.tariffs && this.tariffs.ElectricityRedeliveryTariffs;
		},
		hasGas: function () {
			return this.tariffs && this.tariffs.GasTariffs;
		},
	},
	mounted() {},
};
</script>

<style></style>
